import { Component, HostBinding, Input } from '@angular/core';

/**
 * Look of one route stop on the delivery plan viewer map: a colored badge ("3D" / "1P"), the order
 * code and "ETA: HH:mm" below it. Created dynamically by DeliveryPlanViewerComponent (one per
 * marker) and handed to Leaflet as the content of an L.divIcon; it is not used in templates.
 */
@Component({
    selector: 'app-delivery-plan-viewer-stop-marker',
    templateUrl: './delivery-plan-viewer-stop-marker.component.html',
    styleUrls: ['./delivery-plan-viewer-stop-marker.component.scss'],
})
export class DeliveryPlanViewerStopMarkerComponent
{
    @Input() public stopNumber = 0;
    @Input() public isPickup = false;
    @Input() public isUnassigned = false;
    @Input() public color = "";
    @Input() public orderCode = "";
    @Input() public eta = "";

    @HostBinding("class.is-selected")
    @Input()
    public selected = false;

}